import type {BudgetCategory,Expense,Trip} from './types';

export function budgetTotals(trip:Trip,categories:BudgetCategory[],expenses:Expense[]){
 const travelBudget=trip.travelBudget??(categories.reduce((sum,category)=>sum+category.limit,0)||trip.budget||0);
 const allSpent=expenses.reduce((sum,expense)=>sum+expense.amountTwd,0);
 const prepaid=expenses.reduce((sum,expense)=>sum+(expense.excludeFromAvailable?expense.amountTwd:0),0);
 const tripSpent=allSpent-prepaid;
 return {travelBudget,tripSpent,prepaid,allSpent,remaining:travelBudget-tripSpent};
}
